module.exports = __webpack_public_path__ + "static/img/14000590.6668ce4c.png";